import { normalize, schema } from 'normalizr'
import { AnyAction } from 'redux'

import requestStatuses, { RequestStatuses } from '@cinch/oxd-utils/request-status/src'

import * as types from '../types'

interface State {
  status: { [id: string]: RequestStatuses }
  byId: { [id: string]: Cinch.DirectVehicleSummaryResponse }
  allIds: string[]
  availableIds: string[]
}

export const initialState: State = {
  status: {},
  byId: {},
  allIds: [],
  availableIds: [],
}

const idAttribute = 'vehicleId'
const vehicles = new schema.Entity('vehicles', undefined, { idAttribute })
const responseSchema = new schema.Array(vehicles)

export default function reducer(state = initialState, action: AnyAction) {
  const { type, payload, meta } = action

  switch (type) {
    case types.VEHICLE_SUMMARY_REQUEST:
      return {
        ...state,
        status: {
          ...state.status,
          [meta[idAttribute]]: requestStatuses.PENDING,
        },
      }
    case types.VEHICLE_SUMMARY_SUCCESS: {
      const response = payload as Cinch.DirectVehicleSummaryResponse
      const data = Object.keys(state.byId).length ? [...Object.values(state.byId), response] : [response]
      const { entities, result } = normalize(data, responseSchema)

      const byId = entities && entities.vehicles ? entities.vehicles : {}
      const allIds = result && result.vehicles
      const availableIds = state.availableIds.includes(response.vehicleId)
        ? response.isAvailable
          ? state.availableIds
          : state.availableIds.filter((id) => id !== response.vehicleId)
        : response.isAvailable
        ? [...state.availableIds, response.vehicleId]
        : state.availableIds

      return {
        ...state,
        status: {
          ...state.status,
          [payload[idAttribute]]: requestStatuses.SUCCESS,
        },
        byId,
        allIds,
        availableIds,
      }
    }
    case types.VEHICLE_SUMMARY_FAILURE:
      return {
        ...state,
        status: {
          ...state.status,
          [meta[idAttribute]]: requestStatuses.ERROR,
        },
      }
    case types.VEHICLE_SUMMARY_ALL_REQUEST:
      return {
        ...state,
        status: {
          ...state.status,
          ...meta.vehicleIds.reduce(
            (accum: { [id: string]: RequestStatuses }, id: string) => ({
              ...accum,
              [id]: requestStatuses.PENDING,
            }),
            {},
          ),
        },
      }
    case types.VEHICLE_SUMMARY_ALL_SUCCESS: {
      const response = payload as Array<Cinch.DirectVehicleSummaryResponse | null>
      const availbleVehicleSummaries = response.reduce(
        (accum, vehicleSummary) => ({
          ...accum,
          ...(vehicleSummary ? { [vehicleSummary.vehicleId]: vehicleSummary } : {}),
        }),
        {} as { [id: string]: Cinch.DirectVehicleSummaryResponse },
      )
      const byId = { ...state.byId, ...availbleVehicleSummaries }
      const availableIds = Object.keys(availbleVehicleSummaries).reduce((ids, id) => {
        return state.availableIds.includes(id) ? ids : [...ids, id]
      }, [] as string[])

      return {
        ...state,
        status: {
          ...state.status,
          ...meta.vehicleIds.reduce(
            (accum: { [id: string]: RequestStatuses }, id: string) => ({
              ...accum,
              [id]: requestStatuses.SUCCESS,
            }),
            {},
          ),
        },
        byId,
        availableIds: [...state.availableIds, ...availableIds],
      }
    }
    // eslint-disable-next-line no-duplicate-case
    case types.VEHICLE_SUMMARY_ALL_REQUEST:
      return {
        ...state,
        status: {
          ...state.status,
          ...meta.vehicleIds.reduce(
            (accum: { [id: string]: RequestStatuses }, id: string) => ({
              ...accum,
              [id]: requestStatuses.ERROR,
            }),
            {},
          ),
        },
      }
    default:
      return state
  }
}
